import { Box, Stack, Typography } from "@mui/material";
import { OrganizationScope } from "~/hooks/useScope";
import { AddButton } from "~/components/add-button";
import { setDocumentTitle } from "~/lib/commonUtils";
import { OrganizationPoliciesTable } from "./components/OrganizationPoliciesTable/OrganizationPoliciesTable";
import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";
import { useOrganizationPoliciesTableData } from "./hooks/useOrganizationPoliciesTableData";
import { usePlatformPoliciesFilterContext } from "~/pages/platform/policies/hooks/usePlatformPoliciesFilterContext";

export interface OrganizationPoliciesPageProps {
  scope: OrganizationScope;
}

export function OrganizationPoliciesPage({
  scope,
}: OrganizationPoliciesPageProps) {
  const { isFeatureEnabled } = useFeatureFlags();
  const title = "Organization Policies";
  setDocumentTitle(title);

  const { tableProps } = useOrganizationPoliciesTableData(scope);

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" mb={5}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 700,
            textTransform: "uppercase",
          }}
        >
          {title}
        </Typography>
        {isFeatureEnabled("Platform Policy Add") && (
          <AddButton href={`/organization/policies/add?${scope.params}`} />
        )}
      </Stack>
      <Stack gap={3}>
        <OrganizationPoliciesFilterForm />
        <OrganizationPoliciesTable {...tableProps} />
      </Stack>
    </Box>
  );
}

function OrganizationPoliciesFilterForm() {
  const { filterForm } = usePlatformPoliciesFilterContext();
  return <>{filterForm}</>;
}
